import { AsyncPipe, DatePipe, NgFor, NgIf, NgStyle } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Area } from 'src/app/shared/model/empleado/area.model';
import { Empleado } from 'src/app/shared/model/empleado/empleado.model';
import { Proyecto } from 'src/app/shared/model/gestion-proyectos/proyecto';
import { GenericoService } from 'src/app/shared/services/generico.service';
import { EmpleadoService } from 'src/app/empleado/empleado.service';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import { SweetAlertComponent } from '../../shared/SweetMesssage';
import { ModalDetalleProyeccionComponent } from '../modal-detalle-proyeccion/modal-detalle-proyeccion.component';
import { TableUtil } from './tableUtil';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';

@Component({
  selector: 'app-dashboardTareas',
  standalone: true,
  templateUrl: 'dashboardTareas.component.html',
  providers: [DatePipe],
  imports: [
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    NgFor,
    NgIf,
    NgxMatSelectSearchModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgStyle,
    AsyncPipe,
    DatePipe,
  ],
})
export class DashboardTareasComponent implements OnInit, OnDestroy {
  readonly dayNames = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
  readonly pageSizeOptions = [10, 20, 50];

  consultaProyeccion = new ConsultaList<Empleado>();
  listaProyeccion: Empleado[] = [];
  requestFilter = new ConsultaList<Proyecto>();
  listaSemanal: any[] = [];
  listaSemanas: any[] = [];
  fechasSemana: string[] = [];
  listaProyectos: Proyecto[] = [];
  areas: Area[] = [];
  clientes: Cliente[] = [];
  proyectoCtrl = new FormControl('');
  filteredProyectos: ReplaySubject<Proyecto[]> = new ReplaySubject<Proyecto[]>(1);
  protected destroy$ = new Subject<void>();

  nombre = '';
  nombreTarea = '';
  idProyecto = '';
  idCliente: number | null = null;
  idArea: number | null = null;
  fec_ini: Date | null = null;
  fec_fin: Date | null = null;
  maxDate: Date | null = null;
  minDate: Date | null = null;
  nomProyecto = '';
  idUsuario: number | null = null;

  fechaLunes!: Date;
  fechaDomingo!: Date;
  a = 0;
  next = false;
  previous = true;

  totalRegistros = 0;
  currentPage = 1;
  pageSize = 10;
  loading = false;
  modalRef!: MatDialogRef<any>;

  constructor(
    private readonly datePipe: DatePipe,
    private readonly genericoService: GenericoService,
    private readonly proyectosService: ProyectosService,
    private readonly empleadosService: EmpleadoService,
    private readonly modal: MatDialog,
    private readonly sweetAlert: SweetAlertComponent,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.consultaProyeccion.regInicial = Constantes.CERO;
    this.consultaProyeccion.regXPagina = this.pageSize;
    this.consultaFechaSemanal();
    this.consultaAreas();
    this.consultaProyectosActivos();
    this.consultaClientes();

    this.proyectoCtrl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.filtraProyectos();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  consultaFechaSemanal(): void {
    const current = new Date();
    this.fechaLunes = new Date(current.setDate(current.getDate() - current.getDay() + 1));
    this.fechaDomingo = new Date(current.setDate(current.getDate() - current.getDay() + 8));
    this.maxDate = this.fechaDomingo;
    this.minDate = new Date();
    this.listaSemanas = [];
    this.a = 0;
    this.next = false;
    this.previous = true;
    this.actualizaSemanaVisible(UrlConstantes.FECHAS_SEMANA, true);
  }

  consultaProyecciones(page: number): void {
    this.currentPage = Math.max(1, page);
    this.loading = this.listaProyeccion.length === 0;
    this.cdr.detectChanges();

    this.consultaProyeccion.regInicial = (this.currentPage - 1) * this.pageSize;
    this.consultaProyeccion.regXPagina = this.pageSize;
    this.consultaProyeccion.param1 = this.datePipe.transform(this.fechaLunes, 'yyyy-MM-dd') || '';
    this.consultaProyeccion.param2 = this.datePipe.transform(this.fechaDomingo, 'yyyy-MM-dd') || '';
    this.consultaProyeccion.param3 = this.nombre;
    this.consultaProyeccion.param5 = this.idCliente;
    this.consultaProyeccion.param6 = this.idArea;
    this.consultaProyeccion.param7 = this.nombreTarea;
    this.consultaProyeccion.param8 = this.idProyecto;
    this.consultaProyeccion.fecha_ini = this.fec_ini ? new Date(this.fec_ini) : null;
    this.consultaProyeccion.fecha_fin = this.fec_fin ? new Date(this.fec_fin) : null;

    this.genericoService.consultarXPaginacion(UrlConstantes.DASHBOARD_TAREAS, this.consultaProyeccion).subscribe({
      next: (res: any) => {
        const rows = Array.isArray(res?.list) ? [...res.list] : [];
        this.totalRegistros = this.resolveTotalRegistros(res, rows);
        this.listaProyeccion = rows;

        const maxPages = this.totalPages;
        if (maxPages > 0 && this.currentPage > maxPages) {
          this.consultaProyecciones(maxPages);
          return;
        }

        if (maxPages === 0) {
          this.currentPage = 1;
        }

        this.loading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.listaProyeccion = [];
        this.totalRegistros = 0;
        this.currentPage = 1;
        this.loading = false;
        this.cdr.detectChanges();
        this.sweetAlert.showSwal('error-message', Constantes.VACIO);
      },
    });
  }

  refrescarProyeccion(): void {
    this.consultaProyecciones(this.currentPage);
  }

  aplicarFiltros(): void {
    this.consultaProyecciones(1);
  }

  limpiaFiltros(): void {
    this.idProyecto = '';
    this.idCliente = null;
    this.idArea = null;
    this.nombre = '';
    this.nombreTarea = '';
    this.fec_ini = null;
    this.consultaProyeccion.fecha_ini = null;
    this.fec_fin = null;
    this.consultaProyeccion.fecha_fin = null;
    this.proyectoCtrl.setValue('', { emitEvent: false });
    this.filteredProyectos.next(this.listaProyectos.slice());
    this.consultaFechaSemanal();
  }

  consultaListaSemanal(): void {
    if (!this.fec_ini || !this.fec_fin) {
      this.consultaFechaSemanal();
      return;
    }

    this.fechaLunes = new Date(this.fec_ini);
    this.fechaDomingo = new Date(this.fec_fin);
    this.maxDate = this.fechaDomingo;
    this.minDate = this.fechaLunes;
    this.fechasSemana = [
      this.datePipe.transform(this.fechaLunes, 'dd/MM/yyyy') || '',
      this.datePipe.transform(this.fechaDomingo, 'dd/MM/yyyy') || '',
    ];

    this.genericoService.obtenerElementoPor2Campos(UrlConstantes.FILTRO_SEMANAS, this.fechasSemana).subscribe((res: any[]) => {
      this.listaSemanas = Array.isArray(res) ? res : [];
      this.a = 0;
      this.listaSemanal = this.listaSemanas[0] || [];
      this.previous = false;
      this.next = this.listaSemanas.length <= 1;
      if (this.listaSemanal.length > 0) {
        this.fechaLunes = this.listaSemanal[0];
        this.fechaDomingo = this.listaSemanal[6];
      }
      this.consultaProyecciones(1);
      this.cdr.detectChanges();
    });
  }

  consultaNextWeek(): void {
    if (!this.fec_ini && !this.fec_fin) {
      this.fechaLunes = new Date(this.fechaLunes.setDate(this.fechaLunes.getDate() - this.fechaLunes.getDay() + 8));
      this.fechaDomingo = new Date(this.fechaDomingo.setDate(this.fechaDomingo.getDate() - this.fechaLunes.getDay() + 8));
      this.actualizaSemanaVisible(UrlConstantes.FECHAS_SEMANA, true);
      return;
    }

    this.a = this.a + 1;
    if (this.a >= this.listaSemanas.length - 1) {
      this.a = Math.min(this.a, Math.max(this.listaSemanas.length - 1, 0));
      this.next = true;
      this.previous = this.listaSemanas.length > 1;
    } else {
      this.next = false;
      this.previous = true;
    }

    this.listaSemanal = this.listaSemanas[this.a] || [];
    if (this.listaSemanal.length > 0) {
      this.fechaLunes = this.listaSemanal[0];
      this.fechaDomingo = this.listaSemanal[6];
    }
    this.consultaProyecciones(1);
  }

  consultaPreviousWeek(): void {
    if (!this.fec_ini && !this.fec_fin) {
      this.fechaLunes = new Date(this.fechaLunes.setDate(this.fechaLunes.getDate() - this.fechaLunes.getDay() - 6));
      this.fechaDomingo = new Date(this.fechaDomingo.setDate(this.fechaDomingo.getDate() - this.fechaLunes.getDay() - 6));
      this.actualizaSemanaVisible(UrlConstantes.FECHAS_SEMANA, true);
      return;
    }

    this.a = Math.max(this.a - 1, 0);
    this.listaSemanal = this.listaSemanas[this.a] || [];
    this.previous = this.a !== 0;
    this.next = false;
    if (this.listaSemanal.length > 0) {
      this.fechaLunes = this.listaSemanal[0];
      this.fechaDomingo = this.listaSemanal[6];
    }
    this.consultaProyecciones(1);
  }

  consultaAreas(): void {
    this.empleadosService.consultaAreas().subscribe((res) => {
      this.areas = res.list;
      this.cdr.detectChanges();
    });
  }

  consultaProyectosActivos(): void {
    this.requestFilter.param1 = this.nomProyecto;
    this.requestFilter.param4 = this.idUsuario;
    this.requestFilter.param6 = 3;
    this.requestFilter.regXPagina = Constantes.DIEZ;

    this.proyectosService.consultaProyectoMongo(this.requestFilter).subscribe((response: any) => {
      this.listaProyectos = response.content || [];
      this.filteredProyectos.next(this.listaProyectos.slice());
      this.cdr.detectChanges();
    });
  }

  filtraProyectos(): void {
    if (!this.listaProyectos) {
      return;
    }

    let search = this.proyectoCtrl.value;
    if (!search) {
      this.filteredProyectos.next(this.getFilteredProjectsByClient(this.listaProyectos));
      return;
    }

    search = search.toLowerCase();
    this.filteredProyectos.next(
      this.getFilteredProjectsByClient(this.listaProyectos).filter((proyecto) => proyecto.nombre.toLowerCase().includes(search))
    );
  }

  consultaClientes(): void {
    this.proyectosService.findAllCustomers(new Cliente()).subscribe((response) => {
      this.clientes = response || [];
      this.cdr.detectChanges();
    });
  }

  filterProjectoCliente(): void {
    this.idProyecto = '';
    this.filteredProyectos.next(this.getFilteredProjectsByClient(this.listaProyectos));
    this.aplicarFiltros();
  }

  clearProjectFilter(): void {
    this.idProyecto = '';
    this.proyectoCtrl.setValue('', { emitEvent: false });
    this.filteredProyectos.next(this.getFilteredProjectsByClient(this.listaProyectos));
    this.aplicarFiltros();
  }

  exportTable(): void {
    TableUtil.exportTableToExcel('dashboardTareasTable');
  }

  viewDetail(nombre: string, idUsuario: number, fecha: any): void {
    if (!fecha) {
      return;
    }

    this.modalRef = this.modal.open(ModalDetalleProyeccionComponent, {
      disableClose: true,
      autoFocus: true,
      width: '65vw',
      maxWidth: '65vw',
      panelClass: ['custom-modalbox', 'detalle-proyeccion-dialog'],
      data: {
        empleado: nombre,
        idUsuario: idUsuario,
        fecha: fecha,
        idProyecto: this.idProyecto,
        idCliente: this.idCliente,
        idArea: this.idArea,
      },
    });

    this.modalRef.afterClosed().subscribe(() => {
      this.refrescarProyeccion();
    });
  }

  onPageSizeChange(value: number): void {
    this.pageSize = Number(value);
    this.consultaProyeccion.regXPagina = this.pageSize;
    this.consultaProyecciones(1);
  }

  onPageChange(page: number): void {
    if (page === this.currentPage || page < 1 || page > this.totalPages) {
      return;
    }

    this.consultaProyecciones(page);
  }

  firstPage(): void {
    this.onPageChange(1);
  }

  previousPage(): void {
    this.onPageChange(this.currentPage - 1);
  }

  nextPage(): void {
    this.onPageChange(this.currentPage + 1);
  }

  lastPage(): void {
    this.onPageChange(this.totalPages);
  }

  get totalPages(): number {
    return this.totalRegistros > 0 ? Math.ceil(this.totalRegistros / this.pageSize) : 0;
  }

  get showPagination(): boolean {
    return this.totalRegistros > 0;
  }

  get rangeEnd(): number {
    return Math.min(this.currentPage * this.pageSize, this.totalRegistros);
  }

  getWeekDate(index: number): any {
    return this.listaSemanal?.[index] || null;
  }

  getWeekRangeLabel(): string {
    if (!this.listaSemanal || this.listaSemanal.length < 7) {
      return 'Semana en curso';
    }

    return `${this.datePipe.transform(this.listaSemanal[0], 'mediumDate')} - ${this.datePipe.transform(this.listaSemanal[6], 'mediumDate')}`;
  }

  getDayEntry(row: Empleado, index: number): any {
    return row?.usuario?.historial?.[index] || { tiempoInvertidoStr: '00:00:00', tiempoRegistradoStr: '00:00:00', color: '#e2e8f0' };
  }

  getDayHours(row: Empleado, index: number): string {
    return this.getDayEntry(row, index)?.tiempoInvertidoStr || '0';
  }

  getDayTrackedHours(row: Empleado, index: number): string {
    return this.getDayEntry(row, index)?.tiempoRegistradoStr || this.getDayHours(row, index);
  }

  getDayStatus(row: Empleado, index: number): string {
    const day = this.getDayEntry(row, index);
    if (day?.tiempoPendiente && day.tiempoPendiente > 0) {
      return `Pendiente ${day.tiempoPendienteStr}`;
    }
    if (day?.tiempoRechazado && day.tiempoRechazado > 0) {
      return `Rechazado ${day.tiempoRechazadoStr}`;
    }
    if (day?.tiempoAprobado && day.tiempoAprobado > 0) {
      return `Aprobado ${day.tiempoAprobadoStr}`;
    }
    return "Validado";
  }

  getDayColor(row: Empleado, index: number): string {
    return this.getDayEntry(row, index)?.color || '#e2e8f0';
  }

  getPaginationItems(): Array<number | string> {
    if (this.totalPages <= 1) {
      return [1];
    }

    const pages = new Set<number>([
      1,
      this.totalPages,
      this.currentPage - 1,
      this.currentPage,
      this.currentPage + 1,
    ]);

    const sortedPages = Array.from(pages)
      .filter((page) => page >= 1 && page <= this.totalPages)
      .sort((a, b) => a - b);

    const items: Array<number | string> = [];
    for (let index = 0; index < sortedPages.length; index++) {
      const page = sortedPages[index];
      const previous = sortedPages[index - 1];
      if (previous && page - previous > 1) {
        items.push(`ellipsis-${previous}-${page}`);
      }
      items.push(page);
    }

    return items;
  }

  isPageNumber(item: number | string): item is number {
    return typeof item === 'number';
  }

  private actualizaSemanaVisible(url: string, refreshProjection: boolean): void {
    this.fechasSemana = [
      this.datePipe.transform(this.fechaLunes, 'dd/MM/yyyy') || '',
      this.datePipe.transform(this.fechaDomingo, 'dd/MM/yyyy') || '',
    ];

    this.genericoService.obtenerElementoPor2Campos(url, this.fechasSemana).subscribe((res) => {
      this.listaSemanal = Array.isArray(res) ? res : [];
      if (refreshProjection) {
        this.consultaProyecciones(1);
      }
      this.cdr.detectChanges();
    });
  }

  private getFilteredProjectsByClient(proyectos: Proyecto[]): Proyecto[] {
    if (!this.idCliente) {
      return proyectos.slice();
    }

    return proyectos.filter((proyecto) => proyecto.idCliente === +this.idCliente);
  }

  private resolveTotalRegistros(response: any, rows: Empleado[]): number {
    const candidates = [response?.pTotalItems, response?.totalItems, response?.totalRegistros, response?.param4];

    for (const candidate of candidates) {
      const parsed = Number(candidate);
      if (Number.isFinite(parsed) && parsed > 0) {
        return parsed;
      }
    }

    return Array.isArray(rows) ? rows.length : 0;
  }
}
